import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBoldX = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 10,
	height: 10,
	viewBox: "0 0 10 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M1 1L9.00006 9.00006",
		stroke: "#002E5F",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M9 1L0.999945 9.00006",
		stroke: "#002E5F",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgBoldX);
export default ForwardRef;
